import { Link } from 'react-router-dom';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-[#e6f7f5]">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <p className="text-xs md:text-sm text-brand-accent font-medium mb-3 uppercase tracking-wider">
          Confiance & expérience
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-dark mb-4 leading-tight">
          Plus de <span className="font-heading italic text-brand-accent">dix</span> ans au service du 15ᵉ
        </h2>
        <p className="text-sm md:text-base text-brand-text/60 mb-10">
          Devis gratuit · Techniciens salariés · Un seul interlocuteur
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-brand-accent rounded-2xl p-8 md:p-10 relative overflow-hidden shadow-lg">
            <span className="text-6xl md:text-7xl font-bold font-heading text-white">10+</span>
            <p className="text-base md:text-lg mt-4 text-white/90">Années d'expérience sur Paris 15ᵉ</p>
            <p className="text-sm text-white/70">Intervention en 24-48 heures</p>
            <p className="text-sm italic mt-6 text-white/70 font-heading">Votre tranquillité, notre priorité</p>
          </div>
          <div className="bg-brand-mint rounded-2xl p-8 md:p-10 relative overflow-hidden shadow-lg border border-brand-accent/10">
            <span className="text-6xl md:text-7xl font-bold font-heading text-brand-dark">24/48</span>
            <p className="text-base md:text-lg mt-4 text-brand-text/70">Heures d'intervention</p>
            <p className="text-sm text-brand-text/60">Dans tout le 15ᵉ arrondissement</p>
            <p className="text-sm text-brand-text/60 mt-3">Devis gratuit et sans engagement</p>
          </div>
        </div>
      </div>
    </section>
  );
}